import { getProjectWithTaskStatus } from 'reduxpath/ducks/ProjectList/List'
import { getCountries, setSelectionsCountry } from 'reduxpath/ducks/Reference'

import Home from 'units/ProjectList'
import List from 'units/ProjectList/units/List'

const list = (store) => {
  store.dispatch(getCountries((countries) => {
    store.dispatch(setSelectionsCountry(countries.rows))
  }))
  store.dispatch(
    getProjectWithTaskStatus({
      sort: 'endDate ASC',
      limit: 10,
      skip: 0,
      where: {
        status: 4,
      },
    }),
  )
}

export default {
  populate: {
    list,
  },
  components: {
    Home,
    List,
  },
}
